// extracted by extract-css-chunks-webpack-plugin
module.exports = {"title":"app-components-browse-searchdescription--title"};